module.exports = __webpack_public_path__ + "img/peter-thai.c3932c9e.png";